"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Represents codename of Kentico Cloud field types
*/
var FieldType;
(function (FieldType) {
    FieldType["Text"] = "text";
    FieldType["Number"] = "number";
    FieldType["ModularContent"] = "modular_content";
    FieldType["Asset"] = "asset";
    FieldType["DateTime"] = "date_time";
    FieldType["RichText"] = "rich_text";
    FieldType["MultipleChoice"] = "multiple_choice";
    FieldType["UrlSlug"] = "url_slug";
    FieldType["Taxonomy"] = "taxonomy";
    FieldType["Custom"] = "custom";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
//# sourceMappingURL=field-type.js.map